"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "switch" };
const _hoisted_2 = { class: "switch-block" };
const _hoisted_3 = ["checked", "value", "name"];
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "switch-base" }, null, -1);
const _hoisted_5 = { class: "switch-dot peer-checked:translate-x-8 peer-checked:bg-bhp" };
exports.default = (0, vue_1.defineComponent)({
    __name: 'CustomSwitch',
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            default: "",
        },
        value: {
            type: [String, Boolean, Number],
            default: "",
        },
    },
    emits: ["update:checked"],
    setup(__props, { emit }) {
        const props = __props;
        // eslint-disable-next-line no-unused-vars
        const onInput = (event) => {
            const target = event.target;
            emit("update:checked", target.checked);
        };
        return (_ctx, _cache) => {
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("input", {
                        checked: __props.checked,
                        type: "checkbox",
                        class: "sr-only peer",
                        value: __props.value,
                        name: __props.name,
                        onInput: onInput
                    }, null, 40, _hoisted_3),
                    _hoisted_4,
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("span", null, [
                            (0, vue_2.createVNode)(_component_font_awesome_icon, { icon: ['fas', 'check'] })
                        ], 512), [
                            [vue_2.vShow, __props.checked]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("span", null, [
                            (0, vue_2.createVNode)(_component_font_awesome_icon, { icon: ['fas', 'times'] })
                        ], 512), [
                            [vue_2.vShow, !__props.checked]
                        ])
                    ])
                ]),
                (__props.text)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        class: (0, vue_2.normalizeClass)(["switch-text", {
                                'text-black': __props.checked,
                                'text-arrow-color': !__props.checked,
                            }])
                    }, (0, vue_2.toDisplayString)(__props.text), 3))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
